import { useEffect } from "react";

import { useOrganization } from "@/hooks/use-organization";
import { setOrganizationContext } from "@/utils/analytics";

/**
 * The single point where analytics touches application state.
 *
 * Renders nothing. Mounted once beside `ScrollToTop`, inside
 * `OrganizationProvider`, so that instrumentation lives in one file rather
 * than as effects and handlers spread through feature components that other
 * people are actively reworking. A refactor of the intake UI cannot displace
 * or silently break what is captured, because nothing is captured there.
 *
 * Every call below is a no-op when no PostHog key is configured.
 */
export default function AnalyticsBridge() {
  const { currentOrganization, loading } = useOrganization();

  useEffect(() => {
    setOrganizationContext({
      organizationId: currentOrganization?.id,
      loading,
    });
  }, [currentOrganization?.id, loading]);

  return null;
}
